<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Set Balance</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>


		<v-form class="form-element hasToolbar grey-back" id="form">

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<v-layout wrap padding-top-ten white-background>

				<v-flex xs12 sm12 md12 form-item @click="fn_openAccountLedger">
	               	<v-text-field  
		               	readonly
		               	v-model="Form.accountLedgerName" 
		               	label="Party"
		               	:onUpdate="fn_updateAccountLedger" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	ref="ref_accountLedger"
		               	v-validate="'required'" 
	               		data-vv-name="account ledger" 
	               		:error-messages="errors.collect('account ledger')"
	               		required>
	               	</v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item @click="fn_openDatePicker">
	               	<v-text-field 
	               		readonly
	               		append-icon="arrow_drop_down"
	               		:value="fn_getTransactionDate()" 
	               		label="Date" 
	               		placeholder=" "
	               		v-validate="'required'" 
	               		data-vv-name="date" 
	               		:error-messages="errors.collect('date')"
	               		required>
	               	</v-text-field>
	            </v-flex>

	            <v-subheader full-width subheader-dense font12>Balance Type</v-subheader>
	            <v-flex xs12 sm12 md12 form-item v-if="Form.ledgerData">
	               	<v-radio-group class="ma-0" v-model="Form.balanceType" row>
	               		<v-radio :label="$root.fn_payOrReceive(1, Form.ledgerData.groupTypeId)" :value="1"></v-radio>
				      	<v-radio :label="$root.fn_payOrReceive(0, Form.ledgerData.groupTypeId)" :value="0"></v-radio>
				    </v-radio-group>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
	               	<v-text-field 
	               		type="number" 
	               		:prefix="Form.balanceType == 1 ? '(+)' : '(-)'"
	               		v-model.number="Form.amount" 
	               		label="New Balance"
	               		placeholder=" "
	               		v-validate="'required|min_value:0|decimal:2'" 
	               		data-vv-name="amount"
	               		data-vv-as="new balance" 
	               		:error-messages="errors.collect('amount')"
	               		required>
	               	</v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
					<span class="color-light-grey">Balance As On: </span>&#8377; {{$root.numberToLocale(Form.balanceAsOn)}}
				</v-flex>

	            <v-flex xs12 sm12 md12 form-item mt-3 pb-3>
					<span class="color-light-grey">Difference: </span>&#8377; {{$root.numberToLocale(difference)}} {{difference < 0 ? '(Negative)' : '(Positive)'}}
				</v-flex>
	            
			</v-layout>

			<div id="note" v-if="Form.transactionData.notes" class="margin-top-ten">
				<v-list full-width nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
            					Edit
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-divider></v-divider>

				<v-card flat class="note-card">
					<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</div>
		
		</v-form>


	    <dialog-note ref="ref_dialogNote"></dialog-note>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-datepicker ref="ref_dialogDatePicker" :minDate="minTransactionDate" :maxDate="maxTransactionDate" :selected="Form.transactionData.transactionDate" :updateDate="fn_updateDate"></dialog-datepicker> -->
		<dialog-datepicker ref="ref_dialogDatePicker" :selected="Form.transactionData.transactionDate" :updateDate="fn_updateDate"></dialog-datepicker>

		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;
const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;
const fixedAccountIds = require('../../../../config.js').configs.fixedAccountIds;

const transactionData = require('../../datamodel').data.transactionData;

import dialogNote from '../dialogs/dialog_note'
import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'
import dialogDatePicker from './dialogs/dialog_datepicker'

import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'



const transactionTypes = require('../../../../config.js').configs.transactionTypes;

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		data(){
			return{

				Form:{
					"transactionData": JSON.parse(JSON.stringify(transactionData)),
					"accountLedgerId":null,
					"accountLedgerName":null,
					"amount":null, 
					"amountType":null,
					"balanceType":1,
					"ledgerData":null,
					"balanceAsOn":null
				},


				loading:false,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,
				loadedFromDraft:false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// selectedDate:new Date(),
				newLedgerGroupTypeId:null
			}
		},
		components:{
			'dialog-note':dialogNote,
			'dialog-discard': dialogDiscard,
			'dialog-datepicker':dialogDatePicker,
			'dialog-confirmation':dialogConfirmation,
			'dialog-drive-alert':dialogDriveAlert
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.accountLedgerName);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		methods:{

			// fn_changeAmountType: function(value){
			// 	let self = this;
				
			// 	if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.customer && value == 1){
			// 		this.Form.showBwb = true;
			// 	}
			// 	else if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.supplier && value == 0){
			// 		this.Form.showBwb = true;
			// 	}
			// 	else{
			// 		this.Form.showBwb = false;
			// 	}
			// },

			// fn_getBalanceLabel: function(){
			// 	let type = '';
			// 	if(this.Form.ledgerData && this.Form.ledgerData.balance){
			// 		type = this.Form.ledgerData.balance < 0 ? ' (Cr)' : ' (Dr)';
			// 	}
			// 	return "Amount" + type;
			// },

			// fn_getBalance: function(){
			// 	if(this.Form.ledgerData && this.Form.ledgerData.balance){
			// 		return "Current Balance: " + this.Form.ledgerData.balance;
			// 	}
			// 	else{
			// 		return "Current Balance: 0"	
			// 	}
			// },

			// fn_getDifference: function(){
			// 	if(this.Form.ledgerData && this.Form.ledgerData.balance){
			// 		return this.roundUpto2Decimals(this.Form.ledgerData.balance - this.Form.Amount)
			// 	}
			// 	else{
			// 		return this.Form.Amount;
			// 	}	
			// },
			

			fn_openConfirmationDialog: function () {
				this.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogConfirmation');
			},

			fn_openDatePicker: function () {
				let self = this;
				setTimeout(function () {
					self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
				})
			},

			fn_updateDate: function (value) {
				// this.Form.transactionData.transactionDate = value;
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
				this.fn_getBalanceAsOn();
				this.fn_closeDialog();
			},

			fn_getTransactionDate: function(){
				if(!this.Form.transactionData.transactionDate){
					// this.Form.transactionData.transactionDate = new Date();
					if(new Date().getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
						this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
					}
					else{
						this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();	
					}
				}
				return this.$moment(this.Form.transactionData.transactionDate).format('DD-MMM-YYYY');
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard');
			},

			fn_comingSoon: function () {
				this.showToast("Coming Soon...");
			},

			fn_openAccountLedger: function () {
				this.fn_openAccountLedgerDialog('android', 'AccountLedger', 'ref_accountLedger')
			},

			fn_openAccountLedgerDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.enableFilterChip = true;

				let defaultGroupTypeId = 101;

				// viewDialogObject.groupTypeId = this.Form.partyId ? this.Form.partyDetails.groupTypeId : defaultGroupTypeId;
				viewDialogObject.groupTypeId = this.Form.ledgerData && this.Form.ledgerData.groupTypeId ? this.Form.ledgerData.groupTypeId : defaultGroupTypeId;

				this.newLedgerGroupTypeId = viewDialogObject.groupTypeId;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.accountLedgerId && this.Form.accountLedgerName){
					paramObject.defaultValue = {"id":this.Form.accountLedgerId, "name":this.Form.accountLedgerName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountLedgerId = selectedValueId;
	        		this.Form.accountLedgerName = selectedValueName;
	        		this.fn_getLedgerData(selectedValueId);
	        		this.$forceUpdate();
		        	// this.errors.remove('customer');
				}
				else{
					this.Form.accountLedgerId = null;
		        	this.Form.accountLedgerName = null;
		        	this.fn_clearForm();
				}

			},

			fn_getLedgerData: function(selectedValueId){
				let self = this;
				this.getData('Ledger', selectedValueId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.Form.ledgerData = JSON.parse(response);
							self.fn_getBalanceAsOn();
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_getBalanceAsOn: function(){
				let self = this;
				let filterObject = {};
				filterObject.accountId = this.Form.accountLedgerId;
				filterObject.endDate = this.Form.transactionData.transactionDate;
				this.getFilterData('BalanceAsOn', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let balance = response == "null" ? 0 : response;
							self.Form.balanceAsOn = Number(balance);
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_getBottomMenu: function (tagId) {
				let bottomMenu = null;

				let menuItem_Note = null;
				!this.Form.transactionData.notes ? menuItem_Note = menuItem.addNote : menuItem_Note = menuItem.editNote;

				bottomMenu = {"BottomMenu": [menuItem.save, menuItem_Note,  menuItem.reset]};

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				this.showLoading('Please wait...');
				this.$validator.validateAll().then((result) => {
			        if (result) {
			           	this.fn_post();
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        	this.hideLoading();
			        }
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('SetPartyBalance', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.fn_cleanUp();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				        }
					}
		        );
			},

			fn_cleanUp: function () {
	          	let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.hideLoading();
					self.$router.go(-1);
				});
			},

			fn_post: function(){

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.partyId = this.Form.accountLedgerId;

				this.Form.transactionData.amount = this.Form.amount  //debit or credit amount
				this.Form.transactionData.roundedAmount = Math.round(this.Form.amount); //or creditTotal amount
				this.Form.transactionData.status = 1;
				this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
				this.Form.transactionData.refDate = null;

				// this.Form.transactionData.grossAmount = this.Form.amountType ? this.Form.amount : -this.Form.amount;
				this.Form.transactionData.grossAmount = this.Form.amount;

				let postObj = {};
				postObj = JSON.parse(JSON.stringify(this.Form.transactionData));

				//Preparing Object for transaction ledger table
				let transactionLedgerObj = {};

				transactionLedgerObj.transactionLedgerId = this.guid();
				transactionLedgerObj.accountLedgerId = this.Form.accountLedgerId;
				transactionLedgerObj.orderNumber = 1;
				transactionLedgerObj.amount = this.Form.amount;
				transactionLedgerObj.amountType = this.Form.amountType;

				postObj.transactionLedgers = [];
				postObj.transactionLedgers.push(transactionLedgerObj);
				
				//Preparing Object for ledger accounts table
				let partyAccountObj = {};
				postObj.ledgerAccounts = [];

				partyAccountObj.ledgerAccountId = this.guid();
				partyAccountObj.accountId =  this.Form.accountLedgerId;
				// partyAccountObj.amount =  this.Form.amountType == 1 ? this.Form.amount : -this.Form.amount;
				// partyAccountObj.amount =  this.Form.amount;
				partyAccountObj.amount =  this.difference;
				// partyAccountObj.amountType = this.Form.amount >= 0 ? 1 : 0;
				// partyAccountObj.amountType = this.difference >= 0 ? 1 : 0;k
				partyAccountObj.amountType = this.Form.amountType;
				postObj.ledgerAccounts.push(partyAccountObj);

				// debtor/creditor written off account
				let writtenOffAccountObj = {};
				writtenOffAccountObj.ledgerAccountId = this.guid();
				if(this.Form.ledgerData.accountGroupId == accountGroupIds.creditors.id){
					writtenOffAccountObj.accountId = fixedAccountIds.creditorWrittenOffAccount.id;
				}
				else if(this.Form.ledgerData.accountGroupId == accountGroupIds.debtors.id){
					writtenOffAccountObj.accountId = fixedAccountIds.debtorWrittenOffAccount.id;
				}
				else{
					if(this.Form.amountType==1){
						writtenOffAccountObj.accountId = fixedAccountIds.debtorWrittenOffAccount.id;		
					}
					else{
						writtenOffAccountObj.accountId = fixedAccountIds.creditorWrittenOffAccount.id;	
					}
				}
				// writtenOffAccountObj.amount =  this.Form.amountType == 1 ? -this.Form.amount : this.Form.amount;
				writtenOffAccountObj.amount =  -this.difference;
				// writtenOffAccountObj.amountType = this.Form.amountType == 1 ? 0 : 1;
				// writtenOffAccountObj.amountType = this.difference >= 0 ? 1 : 0;
				writtenOffAccountObj.amountType = this.Form.amountType == 1 ? 0 : 1;
				postObj.ledgerAccounts.push(writtenOffAccountObj);

				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

				console.log(JSON.stringify(postObj));
				this.fn_saveLocal(postObj);
			},

			fn_clearForm: function(){
				this.Form = {
					"transactionData": JSON.parse(JSON.stringify(transactionData)),
					"accountLedgerId":null,
					"accountLedgerName":null,
					"amount":null, 
					"amountType":null,
					"balanceType":1,
					"ledgerData":null
				}
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					let groupTypeId = this.newLedgerGroupTypeId ? this.newLedgerGroupTypeId : 101;
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId: groupTypeId, ls:1}});
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
				else if(menuAction=='addnote'){
					this.fn_addNote();
				}
			},

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#note', self.scrollOptions);
				},300);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_resetForm: function () {
				this.unwatch = true;
				this.loadedFromDraft = false;
				this.fn_clearForm();
				this.fn_removeDraft(this.draftStorageId);
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				let itemData = null;
				if(localStorage.getItem('newItem')){

					itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
					    case "ledger":
					    	this.fn_updateAccountLedger(itemData.id, itemData.name, false)
					        break;
					        
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				if(this.$route.query && this.$route.query.dt && !itemData){
					this.fn_updateAccountLedger(this.$route.query.id, this.$route.query.name, false);
				}
			},

			fn_selectedGroupTypeId: function(groupTypeId){
				this.newLedgerGroupTypeId = Number(groupTypeId);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		computed:{
			// minTransactionDate: function(){
	    	// 	let defaultMinDate = new Date(this.$root.minDateSelection);
    		// 	let month = ("0" + (defaultMinDate.getMonth() + 1)).slice(-2);
    		// 	let date = ("0" + defaultMinDate.getDate()).slice(-2);
    		// 	return this.fn_getFiscalYear(this.Form.transactionData.transactionDate) + "-" + month + "-" + date;
	    	// },
	    	// maxTransactionDate: function(){
	    	// 	return (this.fn_getFiscalYear(this.Form.transactionData.transactionDate)+1) + "-03-31";
	    	// },
	    	difference: function(){
	    		// let amount = this.Form.amountType == 1 ? this.Form.amount : -this.Form.amount;
	    		let amount = this.Form.balanceType == 1 ? this.Form.amount : -this.Form.amount;
	    		let diff = this.roundUpto2Decimals(amount - this.Form.balanceAsOn);
	    		this.Form.amountType = diff < 0 ? 0 : 1;
	    		return diff;
	    		// return this.roundUpto2Decimals(amount - this.Form.balanceAsOn);
	    	}
		},
		mounted: function(){
			console.log(this.$route);

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				// !this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") ?  this.fn_checkTransactionCount() : '';
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ?  this.fn_checkTransactionCount() : '';
			if(!this.$root.CurrentBusiness.DataDrive){
				this.fn_checkTransactionCount(()=>{
					if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
						this.fn_openDialogDriveSetup();
					}
				})
			}

			var formsArray = [];
			if(localStorage.getItem('setpartybalance')){
				formsArray = JSON.parse(localStorage.getItem('setpartybalance'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('setpartybalance', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_selectedGroupTypeId = this.fn_selectedGroupTypeId;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			              self.loadedFromDraft = true;
			            }
					}

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('temp', 'Set Party Balance');
		},
		// beforeRouteEnter (to, from, next) {
		//   	next(vm => {

		//   		let itemId = null;

		//   		//edit from display view 
		//   		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
		// 			itemId = from.params.tagId;
		// 		}

		// 		//edit from list view
		//   		else if(from.name=='openingLedgerItems' && (to.params && to.params.tagId)){
		//   			itemId = to.params.tagId;
		//   		}

		//   		//checking if draft exist
		//   		vm.fn_isDraft(function(isDraft){
		//   			if(itemId && !isDraft){
		//   				vm.fn_get('Transaction', itemId);
		//   			}

		//   			if(!isDraft && !itemId && !localStorage.getItem('newItem') && (to.query && !to.query.dt)){
		//   				if(!vm.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive")){
		//                     vm.fn_checkTransactionCount(function(transactionCount){
		//                         if(transactionCount < 10){
		//                             setTimeout(function(){
		//                                 vm.fn_openAccountLedger();
		//                             },300);
		//                         } 
		//                     })  
		//                 }
		//                 else{
		//                 	setTimeout(function(){
	 //                            vm.fn_openAccountLedger()
	 //                        },300);
		//                 }
		//   			}
		//   		})
		//   	})
		// },
		beforeRouteUpdate (to, from, next) {
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('setpartybalance'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true, 1);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						this.backButtonPress = false;
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
				if(this.askToDiscard){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					localStorage.removeItem('setpartybalance');
					localStorage.removeItem("SetDataDrive");
					next();	
				}
			}
	    },
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/party_balance/form.vue